import $ from 'jquery';
import 'slick-carousel';

var $slider = $('.js-slider');

$slider.on('init', function () {
    $('.slider__load-image').hide();
});

$slider.each(function () {
    var $nav = $(this).siblings('.slider__nav');

    $(this).slick({
        autoplay: true,
        autoplaySpeed: 7000,
        fade: true,
        infinite: true,
        arrows: true,
        dots: true,
        appendArrows: $nav,
        appendDots: $nav,
        draggable: false,
        prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 32 32"><defs><style>.cls-1{fill:#7f7f7f;}</style></defs><path class="cls-1" d="M16.93942,22.35348,11.293,16.70711a1,1,0,0,1,0-1.41422l5.64638-5.64637a.5.5,0,0,1,.7071,0l.707.707a.5.5,0,0,1,0,.7071L13.41406,16l4.93942,4.93942a.5.5,0,0,1,0,.7071l-.707.707A.5.5,0,0,1,16.93942,22.35348Z"/></svg></div>',
        nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 32 32"><defs><style>.cls-1{fill:#7f7f7f;}</style></defs><path class="cls-1" d="M14.35348,22.35348l-.707-.707a.5.5,0,0,1,0-.7071L18.58594,16l-4.93942-4.93942a.5.5,0,0,1,0-.7071l.707-.707a.5.5,0,0,1,.7071,0L20.707,15.29289a1,1,0,0,1,0,1.41422l-5.64638,5.64637A.5.5,0,0,1,14.35348,22.35348Z"/></svg></div>',
        responsive: [{
            breakpoint: 992,
            settings: {
                draggable: true
            }
        }]
    });
});

$('.slider__video-disclaimer').on('click', function() {
    $(this).siblings('.slider__video-button').addClass('slider__video-button--hidden');
    $(this).siblings('.slider__video-placeholder').addClass('slider__video-placeholder--hidden');
    $(this).addClass('slider__video-disclaimer--hidden');
    var src = $(this).siblings('.slider__video-frame').attr('data-src');
    $(this).siblings('.slider__video-frame').attr('src', src);
});
